// BouncyMapPin.tsx
import { motion } from "framer-motion";
import { useTheme } from "@mui/material";
import { MapPin } from "@phosphor-icons/react";

const BouncyMapPin = () => {
  const theme = useTheme();

  return (
    <motion.div
      animate={{
        y: [0, -12, 0],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      style={{ display: "flex", alignItems: "center" }}
    >
      <MapPin size={24} color={theme.palette.primary.main} weight="bold" />
    </motion.div>
  );
};

export default BouncyMapPin;
